import Alpine from 'alpinejs';

Alpine.data('mobileFilters', () => ({
  events: {
    ['x-on:keydown.escape.window.prevent']() {
      this.close();
    },
    ['x-on:mobile-filters:open.window']() {
      this.open();
    },
    ['x-on:mobile-filters:close.window']() {
      this.close();
    },
  },
  open() {
    this.$root.showModal();
  },
  close() {
    this.$root.close();
  },
  submit() {
      const data = new FormData(this.$event.target);
      const value = Object.fromEntries(data.entries());

      // find "filter.v.price", get its value (should be like "10-50"), split on "-", convert to min and max and update filter.v.price.gte and filter.v.price.lte
      if (value['filter.v.price']) {
        const [min, max] = value['filter.v.price'].split('-');
        value['filter.v.price.gte'] = min;
        value['filter.v.price.lte'] = max;
        delete value['filter.v.price'];
      }

      window.location.href = `${window.location.pathname}?${new URLSearchParams(value).toString()}`;
  }
}));